import { useMemo } from 'react';
import useDynamicPageInfo from './useDynamicPageInfo';
import useRouteParams from './useRouteParams';
import { CRM_DYNAMIC_PAGE_REGEX, HUBDB_REGEX } from '../constants/dynamicPage';
const getContentIdStr = ({
  isHubDbPage,
  isCrmDynamicPage,
  contentIdParam
}) => {
  if (isHubDbPage) {
    const hubDbRegExMatches = HUBDB_REGEX.exec(contentIdParam);
    return hubDbRegExMatches && hubDbRegExMatches.length > 1 ? hubDbRegExMatches[1] : '';
  } else if (isCrmDynamicPage) {
    const crmDynamicPageRegExMatches = CRM_DYNAMIC_PAGE_REGEX.exec(contentIdParam);
    return crmDynamicPageRegExMatches && crmDynamicPageRegExMatches.length > 1 ? crmDynamicPageRegExMatches[1] : '';
  }
  return contentIdParam;
};
const useContentId = () => {
  const {
    contentId: contentIdParam
  } = useRouteParams();
  const {
    isHubDbPage,
    isCrmDynamicPage
  } = useDynamicPageInfo();

  // Checks if either a dynamic page - format is "hubdb-{pageId}-{tableId}-{rowId}" or "crm-{pageId}-{a}-{b}-{c}"
  // or a page from old analytics (where analyticsPageId !== pageId) - format is "{analyticsPageId}-{portalId}"
  const contentId = useMemo(() => {
    const contentIdStr = getContentIdStr({
      isHubDbPage,
      isCrmDynamicPage,
      contentIdParam
    });
    try {
      if (contentIdStr) {
        return parseInt(contentIdStr, 10);
      }
      return -1;
    } catch (e) {
      return -1;
    }
  }, [contentIdParam, isHubDbPage, isCrmDynamicPage]);
  return contentId;
};
export default useContentId;